//我们一般使用getters来获取state的状态，而不是直接使用state

export const userInfo = state => {
  return state.userInfo;
};

export const isLoading = state => {
  return state.isLoading;
};

export const token = state => {
  return state.token;
};

export const cartItemData = state => {
  return state.cartItemData;
};

export const isShowLoginModel = state => {
  return state.isShowLoginModel;
};

export const auctionRecordItem = state => {
  return state.auctionRecordItem;
};
